// extracted by css-extract-rspack-plugin
export default {"underlined":"underlined___fVjeo3FA"};